export default __webpack_public_path__ + "static/media/vip-4.343bf8df.svg";